<template>
  <div>
    <div class="box +bg-gray-lighter --left-accent-blue-light">
      <p class="+text-size-xs +fg-gray-darkest">
        At Bankrate we strive to help you make smarter financial decisions.
        While we adhere to strict
        <anchor-modal :anchorText="editorialAnchorText">
          <article class="+mg-md +text-size-xs">
            <h2 class="heading-secondary +heading-epsilon +mg-bottom-sm">
              Editorial Integrity
            </h2>
            <p>
              Bankrate follows a strict editorial policy, so you can trust that
              we’re putting your interests first. Our award-winning editors and
              reporters create honest and accurate content to help you make the
              right financial decisions.
            </p>
            <h3 class="heading-tertiary +heading-epsilon +mg-bottom-sm">
              Key Principles
            </h3>
            <p>
              We value your trust. Our mission is to provide readers with
              accurate and unbiased information, and we have editorial standards
              in place to ensure that happens. Our editors and reporters
              thoroughly fact-check editorial content to ensure the information
              you’re reading is accurate. We maintain a firewall between our
              advertisers and our editorial team. Our editorial team does not
              receive direct compensation from our advertisers.
            </p>
            <h3 class="heading-tertiary +heading-epsilon +mg-bottom-sm">
              Editorial Independence
            </h3>
            <p>
              Bankrate’s editorial team writes on behalf of YOU – the reader.
              Our goal is to give you the best advice to help you make smart
              personal finance decisions. We follow strict guidelines to ensure
              that our editorial content is not influenced by advertisers. Our
              editorial team receives no direct compensation from advertisers,
              and our content is thoroughly fact-checked to ensure accuracy. So,
              whether you’re reading an article or a review, you can trust that
              you’re getting credible and dependable information.
            </p>
          </article>
        </anchor-modal>
        this post may contain references to products from our partners. Here’s
        an explanation for
        <anchor-modal :anchorText="moneyAnchorText">
          <article class="+mg-md +text-size-xs">
            <h2 class="heading-secondary +heading-epsilon +mg-bottom-sm">
              How We Make Money
            </h2>
            <p>
              You have money questions. Bankrate has answers. Our experts have
              been helping you master your money for over four decades. We
              continually strive to provide consumers with the expert advice and
              tools needed to succeed throughout life’s financial journey.
            </p>
            <p>
              Bankrate follows a strict editorial policy, so you can trust that
              our content is honest and accurate. Our award-winning editors and
              reporters create honest and accurate content to help you make the
              right financial decisions. The content created by our editorial
              staff is objective, factual, and not influenced by our
              advertisers.
            </p>
            <p>
              We’re transparent about how we are able to bring quality content,
              competitive rates, and useful tools to you by explaining how we
              make money.
            </p>
            <p>
              Bankrate.com is an independent, advertising-supported publisher
              and comparison service. We are compensated in exchange for
              placement of sponsored products and, services, or by you clicking
              on certain links posted on our site. Therefore, this compensation
              may impact how, where and in what order products appear within
              listing categories. Other factors, such as our own proprietary
              website rules and whether a product is offered in your area or at
              your self-selected credit score range can also impact how and
              where products appear on this site. While we strive to provide a
              wide range offers, Bankrate does not include information about
              every financial or credit product or service.
            </p>
          </article>
        </anchor-modal>
      </p>
      <p v-if="isCC" class="+text-size-xs +fg-gray-darkest">
        The content on this page is accurate as of the posting date; however,
        some of the offers mentioned may have expired.
      </p>
    </div>
  </div>
</template>

<script>
import AnchorModal from '../anchor-modal/anchor-modal.vue'

export default {
  data() {
    return {
      editorialAnchorText: 'editorial integrity,',
      moneyAnchorText: 'how we make money.',
      isCC: window.isCC ? window.isCC : false
    }
  },
  components: {
    'anchor-modal': AnchorModal
  }
}
</script>
